import { Injectable, signal } from "@angular/core";

export type ToastType = "success" | "danger" | "info" | "warning";

export interface Toast {
  id: number;
  type: ToastType;
  message: string;
}

@Injectable({ providedIn: "root" })
export class ToastrService {
  private nextId = 0;
  private readonly toasts = signal<Toast[]>([]);

  readonly items = this.toasts.asReadonly();

  private readonly defaultDuration = 3000;

  success(message: string, duration = this.defaultDuration): void {
    this.show("success", message, duration);
  }

  danger(message: string, duration = this.defaultDuration): void {
    this.show("danger", message, duration);
  }

  info(message: string, duration = this.defaultDuration): void {
    this.show("info", message, duration);
  }

  warning(message: string, duration = this.defaultDuration): void {
    this.show("warning", message, duration);
  }

  remove(id: number): void {
    this.toasts.update(items => items.filter(item => item.id !== id));
  }

  clear(): void {
    this.toasts.set([]);
  }

  private show(type: ToastType, message: string, duration: number): void {
    const id = ++this.nextId;
    this.toasts.update(items => [...items, { id, type, message }]);

    if (duration > 0) {
      setTimeout(() => this.remove(id), duration);
    }
  }
}
